import { NJButton } from "@engie-group/fluid-design-system-react";

/** Store filter chip (single-select), built on NJButton. */
export function FilterChip({
  active,
  label,
  onClick,
}: {
  active: boolean;
  label: string;
  onClick: () => void;
}) {
  return (
    <NJButton
      label={label}
      size="small"
      variant={active ? "primary" : "secondary"}
      emphasis={active ? "bold" : "subtle"}
      onClick={onClick}
    />
  );
}
